<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>

          <v-row>
            <v-btn color="primary" class="mx-1 float-left"   @click.stop="openSmediaList()">لیست شبکه‌های اجتمائی ثبت شده</v-btn>
            <v-divider></v-divider>
           
         
            <v-btn
              class="mx-1 float-left"
              color="primary"
              @click.stop="openCreateOrEditDialog()"
            >
              افزودن شبکه اجتماعی </v-btn
            >
          </v-row>
        </v-card-title>
        <v-divider> </v-divider>
        <v-card-text>
          <smedias-list
            v-if="!$store.getters.smediasFormStatus"
          >
          </smedias-list>
        </v-card-text>
      </v-card>
      <smedias-form v-if="$store.getters.smediasFormStatus"> </smedias-form>
 
 
    </v-container>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const merchantRepository = () => RepoFactory.get('merchant');
import SmediasForm from '../components/SmediasForm.vue';
import SmediasList from '../components/SmediasList.vue';
import Helper from '@/core/helpers';

export default {
  components: {
    SmediasForm,
    SmediasList,
  },
  data() {
    return {
      vendorGroupFormIsOpen: false,
    };
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
 
  },
  methods: {

    openCreateOrEditDialog() {
      this.$store.commit('setSmediasFormStatus', true);
      this.$store.commit('setSmediasGroupFormStatus', false);
      
    },
    openCreateOrEditSmediaDialog() {
      this.$store.commit('setSmediasGroupFormStatus', true);
      this.$store.commit('setSmediasFormStatus', false);
    },
    openSmediaList() {
           this.$store.commit('setSmediasGroupFormStatus', false);
      this.$store.commit('setSmediasFormStatus', false); 
    }
  },
};
</script>

<style lang="scss" scoped></style>
